import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    setStatus("sending");
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setStatus("done");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Try again.");
      setStatus("error");
    }
  }

  return (
    <div className="min-h-screen bg-[#f5f2eb] flex items-center justify-center p-6" data-testid="reset-page">
      <div className="w-full max-w-md border border-[#0a0a0a] bg-[#ede8dc] p-8">
        <div className="bm-eyebrow text-neutral-500 mb-2">RESET · STEP 2</div>
        <h1 className="bm-headline text-3xl mb-6">Set a new password.</h1>

        {status === "done" ? (
          <div className="border border-emerald-700 bg-emerald-50 p-4 text-sm" data-testid="reset-done">
            Password updated. Redirecting to sign-in…
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <label className="bm-eyebrow text-neutral-500 block mb-1">New password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-b border-[#0a0a0a] bg-transparent py-2 mb-4 focus:outline-none"
              data-testid="reset-password"
              placeholder="at least 6 characters"
            />
            <label className="bm-eyebrow text-neutral-500 block mb-1">Confirm password</label>
            <input
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full border-b border-[#0a0a0a] bg-transparent py-2 mb-6 focus:outline-none"
              data-testid="reset-confirm"
            />
            {error && <div className="text-sm text-[#c72c2c] mb-3" data-testid="reset-error">{error}</div>}
            <button
              type="submit"
              disabled={status === "sending"}
              className="w-full bg-[#0a0a0a] text-[#f5f2eb] py-3 bm-eyebrow disabled:opacity-60"
              data-testid="reset-submit"
            >
              {status === "sending" ? "Updating…" : "Update password"}
            </button>
          </form>
        )}

        <Link
          to="/login"
          className="bm-eyebrow text-neutral-500 hover:text-[#0a0a0a] block mt-6 text-center"
        >
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
